import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import { useForm } from 'react-hook-form'
import { Button } from '../../Common/ui/button'
import Racilist from './Components/raciLists'
import { useTranslation } from 'react-i18next'
import { RxCrossCircled } from 'react-icons/rx'

const CreateRaciMatrixDialog = ({ isOpen, tempRaciMatrix, raciiMatrices, setRaciiMatrices, onCloseDialog, selectedValues, setSelectedValues, windowWidth, onSave }) => {
    const { control, handleSubmit, reset, formState: { errors, isSubmitting, isLoading } } = useForm({ mode: 'onChange' })

    const handleSave = (data) => {
        const matrices = raciiMatrices.filter(ele => ele.department !== 'nodata' && ele.departmentId !== null && ele.departmentId !== undefined)
        onSave(matrices)
    }
    const { t } = useTranslation()
    const handleClose = () => {
        onCloseDialog()
        reset()
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { overflowX: 'hidden', zIndex: 1300 } }}
        >
            <DialogContent className='flex bg-primary'>
                <div className='text-center flex-grow text-card text-xl'>RACI Matrix</div>
                <div onClick={handleClose} style={{ cursor: 'pointer' }}>
                    <RxCrossCircled size={26} color='hsl(var(--card))' className='my-auto'/>
                </div>
            </DialogContent>
            <DialogContent>
                <Racilist tempRaciMatrix={tempRaciMatrix} raciiMatrices={raciiMatrices} setRaciiMatrices={setRaciiMatrices} editNode={selectedValues} getState={selectedValues} control={control} errors={errors} reset={reset} />
            </DialogContent>
            <DialogActions className='border-t-[1.5px] border-[hsl(var(--primary-foreground))] !py-5'>
                <Button onClick={handleClose} variant="outline">{t('Cancel')}</Button>
                <Button onClick={handleSubmit(handleSave)} disabled={isLoading || isSubmitting}>{t('Save')}</Button>
            </DialogActions>
        </Dialog>
    )
}

CreateRaciMatrixDialog.propTypes = {
    isOpen: PropTypes.bool,
    onCloseDialog: PropTypes.func,
    windowWidth: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    onSave: PropTypes.func,
    selectedValues: PropTypes.array,
    setSelectedValues: PropTypes.func,
    raciiMatrices: PropTypes.array,
    tempRaciMatrix: PropTypes.array,
    setRaciiMatrices: PropTypes.func
}

export default CreateRaciMatrixDialog
